import React from 'react';
import { Turnout, Part, Label, Value } from './styles';
import { percentFormat } from '../../Utils/NumberFormatting'

export default (props) => (
	<Turnout className={props.className}>
		<Part>
			<Label>Volební účast</Label>
			<Value>{percentFormat(props.turnout)}</Value>
		</Part>
		<Part>
			<Label>Sečteno</Label>
			<Value>{percentFormat(props.count)}</Value>
		</Part>
	</Turnout>
)
